import momentTz from 'moment-timezone';

export const getFormattedDateClaimsBff = (date) => momentTz(date).format('MMM D, YYYY');
export const getFormattedDateClaimsGW = (date) => momentTz.utc(date).tz('America/Toronto', true).format('MMM D, YYYY');
